(ns common.schema.entity-types
  (:require
   [clojure.set :as set]
   [common.eid :as eid]
   [common.entity-ownership :as entity-ownership]
   [common.features.plan :as plan]
   [common.roles :as roles]
   [common.schema.assets :as assets]
   [common.schema.entities.account.schema :as account-schema]
   [common.schema.entities.activity :as activity]
   [common.schema.entities.ai-task-config :as ai-task-config]
   [common.schema.entities.ai-usage-event :as ai-usage-event]
   [common.schema.entities.integration.ai-service :as ai-service]
   [common.schema.entities.asset :as asset]
   [common.schema.entities.attachment :as attachment]
   [common.schema.entities.attestation :as attestation]
   [common.schema.entities.attestation-condition :as attestation-condition]
   [common.schema.entities.cached-value :as cached-value]
   [common.schema.entities.system-config :as system-config]
   [common.schema.entities.calculated.indirect-holding :as indirect-holding]
   [common.schema.entities.call :as note-call]
   [common.schema.entities.card :as card]
   [common.schema.entities.change-meta :as change-meta]
   [common.schema.entities.check-list :as check-list]
   [common.schema.entities.common :as common]
   [common.schema.entities.company.schema :as company]
   [common.schema.entities.contact-list :as contact-list]
   [common.schema.entities.counterparty-diligence.company :as company-counterparty-diligence]
   [common.schema.entities.counterparty-diligence.person :as person-counterparty-diligence]
   [common.schema.entities.counterparty-diligence.process :as counterparty-diligence-process]
   [common.schema.entities.counterparty-diligence.project :as project-counterparty-diligence]
   [common.schema.entities.custom-field :as custom-field]
   [common.schema.entities.customer :as customer]
   [common.schema.decision-types :as decision-types]
   [common.schema.entities.decision-advisory-board :as advisory-board-decision]
   [common.schema.entities.decision-aifm-exit :as aifm-exit-decision]
   [common.schema.entities.decision-condition :as decision-condition]
   [common.schema.entities.decision-ic-exit :as ic-exit-decision]
   [common.schema.entities.decision-icm :as icm-decision]
   [common.schema.entities.decision-one-pager :as one-pager-decision]
   [common.schema.entities.decision-participant :as decision-participant]
   [common.schema.entities.decision-pm-approval :as pm-approval-decision]
   [common.schema.entities.decision-scm :as scm-decision]
   [common.schema.entities.declaration :as declaration]
   [common.schema.entities.email :as email]
   [common.schema.entities.email-template :as email-template]
   [common.schema.entities.entity :as entity-schema]
   [common.schema.entities.entity-association :as entity-association]
   [common.schema.entities.exit-opportunity.schema :as exit-opportunity]
   [common.schema.entities.exit-opportunity-stage :as exit-opportunity-stage]
   [common.schema.entities.feedback :as feedback]
   [common.schema.entities.fof-asset :as fof-asset]
   [common.schema.entities.fund.schema :as fund]
   [common.schema.entities.fund-commitment :as fund-commitment]
   [common.schema.entities.fundraising-opportunity.schema :as fundraising-opportunity]
   [common.schema.entities.graph-company :as graph-company]
   [common.schema.entities.graph-entity :as graph-entity]
   [common.schema.entities.graph-fof-asset :as graph-fof-asset]
   [common.schema.entities.graph-fund :as graph-fund]
   [common.schema.entities.graph-meta :as graph-meta]
   [common.schema.entities.graph-person :as graph-person]
   [common.schema.entities.graph-reference :as graph-reference]
   [common.schema.entities.holding.schema :as holding]
   [common.schema.entities.import-data :as import-data]
   [common.schema.entities.insider-group :as insider-group]
   [common.schema.entities.integration.nylas-account :as nylas-account]
   [common.schema.entities.integration.nylas-token :as nylas-token]
   [common.schema.entities.intelligence-data :as intelligence-data]
   [common.schema.entities.investment-reservation :as investment-reservation]
   [common.schema.entities.investment-reservation-type :as investment-reservation-type]
   [common.schema.entities.investor.schema :as investor]
   [common.schema.entities.job :as job]
   [common.schema.entities.kpi-category :as kpi-category]
   [common.schema.entities.kpi-cycle :as kpi-cycle]
   [common.schema.entities.kpi-member :as kpi-member]
   [common.schema.entities.kpi-report :as kpi-report]
   [common.schema.entities.kpi-report-answer :as kpi-report-answer]
   [common.schema.entities.kpi-report-data :as kpi-report-data]
   [common.schema.entities.liability :as liability]
   [common.schema.entities.login-page-config :as login-page-config]
   [common.schema.entities.lp-portal.lp-news-category :as lp-news-category]
   [common.schema.entities.lp-portal.lp-news-item :as lp-news-item]
   [common.schema.entities.lp-portal.lp-news-type :as lp-news-type]
   [common.schema.entities.lp-portal.lp-promotion :as lp-promotion]
   [common.schema.entities.lp-portal.lp-report :as lp-report]
   [common.schema.entities.lp-portal.lp-report-holding :as lp-report-holding]
   [common.schema.entities.lp-portal.lp-report-investor-commitment :as lp-report-investor-commitment]
   [common.schema.entities.meeting :as note-meeting]
   [common.schema.entities.message :as note-message]
   [common.schema.entities.metabase-dashboard :as metabase-dashboard]
   [common.schema.entities.named-value :as named-value]
   [common.schema.entities.named-view.schema :as named-view-schema]
   [common.schema.entities.note :as note]
   [common.schema.entities.oppo.schema :as oppo]
   [common.schema.entities.opportunity-stage :as opportunity-stage]
   [common.schema.entities.other-asset :as other-asset]
   [common.schema.entities.permission-checks :as permission-checks]
   [common.schema.entities.person :as person]
   [common.schema.entities.pipeline :as pipeline]
   [common.schema.entities.pre-exit-check :as pre-exit-check]
   [common.schema.entities.pre-investment-check :as pre-investment-check]
   [common.schema.entities.real-estate :as real-estate]
   [common.schema.entities.related-entities :as related-entities]
   [common.schema.entities.ribbon :as ribbon]
   [common.schema.entities.role :as role]
   [common.schema.entities.sale-agreement :as sale-agreement]
   [common.schema.entities.sales-opportunity.schema :as sales-opportunity]
   [common.schema.entities.sales-opportunity-stage :as sales-opportunity-stage]
   [common.schema.entities.scheduled-job :as scheduled-job]
   [common.schema.entities.screening-profile.schema :as screening-profile-schema]
   [common.schema.entities.signatory :as signatory]
   [common.schema.entities.stage :as stage]
   [common.schema.entities.survey.reminder-rule :as reminder-rule]
   [common.schema.entities.survey.rotation-period :as rotation-period]
   [common.schema.entities.survey.rotation-period-override :as rotation-period-override]
   [common.schema.entities.survey.survey-answer :as survey-answer]
   [common.schema.entities.survey.survey-batch :as survey-batch]
   [common.schema.entities.survey.survey-block :as survey-block]
   [common.schema.entities.survey.survey-cycle :as survey-cycle]
   [common.schema.entities.survey.survey-process :as survey-process]
   [common.schema.entities.survey.survey-profile :as survey-profile]
   [common.schema.entities.survey.survey-question-external-id :as survey-question-external-id]
   [common.schema.entities.survey.survey-question-option :as survey-question-option]
   [common.schema.entities.survey.survey-reminder :as survey-reminder]
   [common.schema.entities.survey.survey-template :as survey-template]
   [common.schema.entities.survey.survey-type :as survey-type]
   [common.schema.entities.system-activity :as system-activity]
   [common.schema.entities.tab :as tab]
   [common.schema.entities.task :as task]
   [common.schema.entities.team :as team]
   [common.schema.entities.tenant :as tenant]
   [common.schema.entities.tenant-inbox :as tenant-inbox]
   [common.schema.entities.token :as token]
   [common.schema.entities.transaction-process :as transaction-process]
   [common.schema.entities.vault.vault-config :as vault-config]
   [common.schema.entities.vault.vault-usage :as vault-usage]
   [common.schema.entities.vault.zap-vault :as zap-vault]
   [common.schema.entities.view :as view]
   [common.schema.entities.volume-data :as volume-data]
   [common.schema.entities.webentry :as webentry]
   [common.schema.entities.workspace.kyc.contract-kyc-profile :as contract-kyc-profile]
   [common.schema.entities.workspace.kyc.kyc-process :as kyc-process]
   [common.schema.entities.workspace.kyc.kyc-risk-category :as kyc-risk-category]
   [common.schema.entities.workspace.kyc.tenant-kyc-profile :as tenant-kyc-profile]
   [common.schema.entities.workspace.workspace :as workspace]
   [common.schema.entities.workspace.workspace-team :as workspace-team]
   [common.schema.entity-type-names :as entity-type-names]
   [common.schema.entity-type-registry :as entity-type-registry]
   [common.transaction-process.access :as tp-access]
   [common.util :as cu]
   [potpuri.core :as potpuri :refer [fn->>]]))

(def HARD-CODED-ENTITY-IDS
  {:entity.type/sync-progress 1
   :entity.type/timezone      2
   :entity.type/sync-reset    3})

(def PUBLIC-ENTITY-TYPES
  [:entity.type/sync-progress
   :entity.type/sync-reset
   :entity.type/timezone
   :entity.type/intelligence-data
   :entity.type/fullcontact-company-common
   :entity.type/fullcontact-person-common
   :entity.type/response-login-get-roles
   :entity.type/history-attribute-change])

(def PUBLIC-ENTITY-TYPES-SET
  (set PUBLIC-ENTITY-TYPES))

(def any-reference-types
  [:entity.type/company
   :entity.type/fof-asset
   :entity.type/real-estate
   :entity.type/other-asset
   :entity.type/person
   :entity.type/oppo
   :entity.type/holding
   :entity.type/fundraising-opportunity
   :entity.type/fund-commitment
   :entity.type/sales-opportunity
   :entity.type/sale-agreement
   :entity.type/exit-opportunity
   :entity.type/investor
   :entity.type/fund])

(def decision-entity-types decision-types/decision-entity-types)

(def decision-associated-entity-types decision-types/decision-associated-entity-types)

(def decision-or-associated-entity-types decision-types/decision-or-associated-entity-types)

(def pipeline-entity-types
  (keys pipeline/entity-type-mappings))

(defn decision-or-associated-entity-type
  [entity-type]
  (decision-types/decision-or-associated-entity-type? entity-type))

(def counterparty-diligence-entity-types
  #{:entity.type/project-counterparty-diligence
    :entity.type/company-counterparty-diligence
    :entity.type/person-counterparty-diligence})

(defn counterparty-diligence-entity-type?
  [entity-type]
  (contains? counterparty-diligence-entity-types entity-type))

;; map-profile-types e.g. :entity.type/graph-company
(def graph-entity-types
  (->> graph-entity/graph-entity-mapping
       keys
       (into #{})))

;; main-entity-types that map-profiles can be created for:
(def graph-for-entity-types
  (->> graph-entity/graph-entity-mapping
       vals
       (into #{})))

(def dont-save-to-frontend-cache
  (set/difference (set
                   (concat PUBLIC-ENTITY-TYPES
                           [:entity.type/history-attribute-change
                            :entity.type/note
                            :entity.type/note-call
                            :entity.type/note-meeting
                            :entity.type/note-message
                            :entity.type/system-activity
                            :entity.type/value-creation
                            :entity.type/scheduled-job
                            :entity.type/feedback]))
                  #{:entity.type/timezone}))

(declare read-permissions?)

(def created-by-account? permission-checks/created-by-account?)

(def write-permissions-to-related-entity? permission-checks/write-permissions-to-related-entity?)

(def activity-delete-check-fn permission-checks/activity-delete-check-fn)

(def risk-delete-check-fn permission-checks/risk-delete-check-fn)

(def liability-delete-check-fn
  (fn [{:keys [tr account role entity has-write-permissions?]}]
    (when-not (or (roles/admin? role)
                  (created-by-account? entity account)
                  (and (roles/user? role)
                       (->> entity
                            :common/_liabilities
                            (remove :common/disabled?)
                            (some has-write-permissions?))))
      (tr :not-allowed))))

(def association-delete-check-fn
  (fn [{:keys [tr account role entity has-write-permissions?]}]
    (when-not (or (roles/admin? role)
                  (created-by-account? entity account)
                  (and (roles/user? role)
                       (write-permissions-to-related-entity? entity has-write-permissions?)))
      (tr :not-allowed))))

(def attachment-delete-check-fn
  (fn [{:keys [tr account role entity has-write-permissions?]}]
    (when-not (or (roles/admin? role)
                  (created-by-account? entity account)
                  (and (roles/user? role)
                       (->> entity
                            :common/_attachments
                            (some has-write-permissions?))))
      (tr :not-allowed))))

(def delete-not-allowed! permission-checks/delete-not-allowed!)

(def abstract-entity-delete-check-fn delete-not-allowed!)
(def calculated-entity-delete-check-fn delete-not-allowed!)
(def deprecated-entity-delete-check-fn delete-not-allowed!)
(def system-controlled-entity-delete-check delete-not-allowed!)

(def crm-delete-check-fn
  (fn [{:keys [tr role]}]
    (when-not (roles/user? role)
      (tr :not-allowed))))

(def owner-admin-check-fn
  (fn [{:keys [role account entity]}]
    (when (:db/id account)
      (or (roles/admin? role)
          (entity-ownership/entity-owner? account entity)))))

(def owner-admin-delete-check-fn
  (fn [{:keys [tr] :as ctx}]
    (when-not (owner-admin-check-fn ctx)
      (tr :only-owner-or-admin-can-delete))))

(def admin-check-fn
  (fn [{:keys [role]}]
    (roles/admin? role)))

(def admin-delete-check-fn
  (fn [{:keys [tr] :as ctx}]
    (when-not (admin-check-fn ctx)
      (tr :only-admin-can-delete-this-entity))))

(def dedicated-delete-should-be-used-fn
  (fn [{:keys [tr entity]}]
    (tr :dedicated-delete-should-be-used [(tr (:entity/type entity))])))

(def zadmin-delete-check-fn
  (fn [{:keys [tr role]}]
    (when-not (roles/zadmin? role)
      (tr :not-allowed))))

(def kpi-delete-check-fn
  (fn [{:keys [tr account-current-permissions] :as ctx}]
    (when-not (or (admin-check-fn ctx)
                  (contains? (:account-modules account-current-permissions)
                             :module/kpi-reporting))
      (tr :not-allowed))))

(def oppo-read-check-fn permission-checks/oppo-read-check-fn)

(def exit-oppo-read-check-fn permission-checks/exit-oppo-read-check-fn)

(def decisions-access? permission-checks/decisions-access?)

(defn entity-graph-access?
  [{:keys [tenant account-current-permissions] :as _ctx}]
  (and (plan/available :feature/entity-graph tenant)
       (contains? (:account-modules account-current-permissions)
                  :module/entity-graph)))

(defn zap-vault-access?
  [{:keys [tenant account-current-permissions] :as _ctx}]
  (and (plan/available :feature/zap-vault tenant)
       (contains? (:account-modules account-current-permissions)
                  :module/zap-vault)))

(defn feature-and-module?
  [{:keys [tenant account-current-permissions] :as _ctx}
   feature-key module-key]
  (and (plan/available feature-key tenant)
       (contains? (:account-modules account-current-permissions)
                  module-key)))

(defn feature-and-admin-or-module?
  [{:keys [tenant role account-current-permissions] :as _ctx} feature-key module-key]
  (and (plan/available feature-key tenant)
       (or (roles/admin? role)
           (and (roles/user? role)
                (contains? (:account-modules account-current-permissions)
                           module-key)))))

(def decision-read-check-fn permission-checks/decision-read-check-fn)

(def decision-disable-permissions-check-fn permission-checks/decision-disable-permissions-check-fn)

(def decision-condition-read-check-fn
  (fn [{:keys [entity] :as ctx}]
    (let [decision (-> entity
                       :decision/_conditions
                       (first))]
      (when decision
        (decision-read-check-fn (assoc ctx :entity decision))))))

(defn decision-condition-disable-permissions-check-fn
  [{:keys [tr entity] :as ctx}]
  (let [decision (-> entity
                     :decision/_conditions
                     first)]
    (if-not decision
      (tr :not-allowed)
      (decision-disable-permissions-check-fn (assoc ctx :entity decision)))))

(def decision-participant-read-check-fn
  (fn [{:keys [entity] :as ctx}]
    (let [decision (-> entity
                       :decision/_participants
                       (first))]
      (when decision
        (decision-read-check-fn (assoc ctx :entity decision))))))

(defn decision-participant-disable-permissions-check-fn
  [{:keys [tr entity] :as ctx}]
  (let [decision (-> entity
                     :decision/_participants
                     first)]
    (if-not decision
      (tr :not-allowed)
      (decision-disable-permissions-check-fn (assoc ctx :entity decision)))))

(def investment-reservation-read-check-fn
  (fn [{:keys [entity] :as ctx}]
    (let [decision (-> entity
                       :decision/_investment-reservations
                       (first))]
      (when decision
        (decision-read-check-fn (assoc ctx :entity decision))))))

(defn investment-reservation-disable-permissions-check-fn
  [{:keys [tr entity] :as ctx}]
  (let [decision (-> entity
                     :decision/_investment-reservations
                     first)]
    (if-not decision
      (tr :not-allowed)
      (decision-disable-permissions-check-fn (assoc ctx :entity decision)))))

(defn counterparty-diligence-read-check-fn
  [{:keys [entity tenant tenant-plan role account-current-permissions] :as ctx}]
  (let [feature-available? (plan/available :feature/counterparty-diligence tenant role tenant-plan)
        account-modules (:account-modules account-current-permissions)
        counterparty-diligence-light-access? (contains? account-modules
                                                        :module/counterparty-diligence)
        counterparty-diligence-admin? (contains? account-modules
                                                 :module/counterparty-diligence-admin)
        source-entity (:project-counterparty-diligence/source-entity entity)
        access-to-source-entity? (when source-entity
                                   (case (:entity/type source-entity)
                                     :entity.type/oppo
                                     (oppo-read-check-fn
                                      (assoc ctx :entity source-entity))

                                     :entity.type/exit-opportunity
                                     (exit-oppo-read-check-fn
                                      (assoc ctx :entity source-entity))

                                     false))
        access? (and feature-available?
                     (or counterparty-diligence-admin?
                         (and counterparty-diligence-light-access?
                              access-to-source-entity?)))]
    access?))

;; TODO: Who can delete?
(defn counterparty-diligence-delete-check-fn
  [ctx]
  (admin-delete-check-fn ctx))

(def counterparty-diligence-process-read-check-fn
  permission-checks/counterparty-diligence-process-read-check-fn)

(defn zap-vault-read-check-fn
  [{:keys [entity tenant role tenant-plan account account-current-permissions]}]
  (and (plan/available :feature/zap-vault tenant role tenant-plan)
       (or (roles/admin? role)
           (contains? (:account-modules account-current-permissions)
                      :module/zap-vault))
       (or (roles/admin? role)
           (= (:db/id account) (->> entity :common/owner :db/id))
           (some #{(:db/id account)} (->> entity
                                          :zap-vault/members
                                          (mapv eid/eid)))
           (some (->> (:zap-vault/teams entity)
                      (map eid/eid)
                      (set))
                 (:account-team-memberships account-current-permissions)))))

(def esign-process-read-check-fn permission-checks/esign-process-read-check-fn)

(defn graph-entity-disable-check
  [{:keys [tr] :as _ctx}]
  ;; should we allow if not a source or target in any graph-reference?
  (tr :not-allowed))

(defn- can-access-tp-sub-entity?
  "Read-access for a TP sub-entity (attestation / declaration): find the parent
   transaction-process via its named slot (v3) and delegate. Replaces the v2
   `:transaction-process/_{attestations,declarations}` reverse-ref lookup."
  [ctx]
  (let [tp (tp-access/find-parent-transaction-process (:entity ctx))]
    (when tp
      (tp-access/can-access-transaction-process? (assoc ctx :entity tp)))))

(defn- can-access-attestation-condition?
  [ctx]
  (let [attestation (->> (:entity ctx)
                         :attestation/_conditions
                         (remove :common/disabled?)
                         first)]
    (when attestation
      (can-access-tp-sub-entity? (assoc ctx :entity attestation)))))

(def entities
  (potpuri/deep-merge
   entity-type-names/entities
   {:entity.type/intelligence-data
    {:entity/schema intelligence-data/schema
     :entity/icon   :fa-network-wired
     :entity/read-permissions-check-fn
     (fn [{:keys []}]
       true)
     :entity/disable-permissions-check-fn
     delete-not-allowed!}
    :entity.type/authentication
    {:entity/read-permissions-check-fn    (constantly false)
     :entity/icon                         :fa-user-check
     :entity/disable-permissions-check-fn system-controlled-entity-delete-check}

    :entity.type/asset
    {:entity/schema                       asset/schema
     :entity/icon                         :fa-bullseye-pointer
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                            true)
     :entity/disable-permissions-check-fn abstract-entity-delete-check-fn}
    :entity.type/activity
    {:entity/schema                       activity/new-activity
     :entity/icon                         :fa-bullseye-pointer
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                            true)
     :entity/disable-permissions-check-fn abstract-entity-delete-check-fn}

    :entity.type/customer
    {:entity/schema                       customer/schema
     :entity/icon                         :fa-hands-helping
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                            true)
     :entity/disable-permissions-check-fn abstract-entity-delete-check-fn}

    :entity.type/company
    {:entity/schema                    company/schema
     :entity/icon                      :fa-building
     :entity/create-icon               :fa-layer-plus
     :entity/read-permissions-check-fn (fn [{:keys []}]
                                         true)
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr entity] :as ctx}]
       (or (crm-delete-check-fn ctx)
           (cond
             (->> entity
                  :oppo/_target-asset
                  (remove :common/disabled?)
                  (seq))
             (tr :cannot-delete-asset-when-target-in-oppo)

             (->> entity
                  :fof-asset/_gp
                  (remove :common/disabled?)
                  (seq))
             (tr :cannot-delete-when-gp-in-fund)

             (->> entity
                  :holding/_target-asset
                  (remove :common/disabled?)
                  (seq))
             (tr :cannot-delete-asset-when-target-in-holding)

             (->> entity
                  :kpi-member/_asset
                  (remove :common/disabled?)
                  (remove (fn->> :kpi-member/target :common/disabled?))
                  (seq))
             (tr :cannot-delete-asset-when-active-in-kpi-reports))))}
    :entity.type/cached-value
    {:entity/schema                       cached-value/schema
     :entity/icon                         :fa-database
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                            true)
     :entity/disable-permissions-check-fn system-controlled-entity-delete-check}

    :entity.type/system-config
    {:entity/schema                       system-config/schema
     :entity/icon                         :fa-gear
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                            true)
     :entity/disable-permissions-check-fn system-controlled-entity-delete-check}

    :entity.type/change-meta
    {:entity/schema                       change-meta/schema
     :entity/icon                         :fa-sliders-h
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                            true)
     :entity/disable-permissions-check-fn system-controlled-entity-delete-check}

    :entity.type/email
    {:entity/schema                           email/new-email
     :entity/icon                             :fa-envelope
     :entity/apply-read-permissions-to-admin? true
     :entity/read-permissions-check-fn
     (fn [{:keys [account entity]}]
        ;; TODO - this only does privacy checking
        ;; a proper check if email is also linked to an entity account has access to needed
        ;; This is currently handled in sync - but ideally would be done here
        ;; same with other entities that are not synced directly
       (and (= :entity.type/email (:entity/type entity))
            (not (email/no-access-to-private-email? account entity))))
     :entity/disable-permissions-check-fn     activity-delete-check-fn}

    :entity.type/email-template
    {:entity/schema                       email-template/schema
     :entity/icon                         :fa-envelope
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                            true)
     :entity/disable-permissions-check-fn admin-delete-check-fn}

    :entity.type/lp-news-category
    {:entity/schema                       lp-news-category/schema
     :entity/icon                         :fa-list-alt
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                             ;;(roles/is-ssg-role?) ;; TODO
                                            )
     :entity/disable-permissions-check-fn admin-delete-check-fn}

    :entity.type/lp-news-item
    {:entity/schema                       lp-news-item/schema
     :entity/icon                         :fa-newspaper
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                             ;;(roles/is-ssg-role?) ;; TODO
                                            )
     :entity/disable-permissions-check-fn admin-delete-check-fn}

    :entity.type/lp-news-type
    {:entity/schema                       lp-news-type/schema
     :entity/icon                         :fa-clipboard-list
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                             ;;(roles/is-ssg-role?) ;; TODO
                                            )
     :entity/disable-permissions-check-fn admin-delete-check-fn}

    :entity.type/lp-promotion
    {:entity/schema                       lp-promotion/schema
     :entity/icon                         :fa-bullhorn
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                             ;;(roles/is-ssg-role?) ;; TODO
                                            )
     :entity/disable-permissions-check-fn admin-delete-check-fn}

    :entity.type/entity-association
    {:entity/schema                       entity-association/schema
     :entity/icon                         :fa-lightbulb
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                            true)
     :entity/disable-permissions-check-fn association-delete-check-fn}

    :entity.type/fof-asset
    {:entity/schema                       fof-asset/schema
     :entity/icon                         :fa-seedling
     :entity/create-icon                  :fa-seedling
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                            true)
     :entity/disable-permissions-check-fn crm-delete-check-fn}
    :entity.type/fund
    {:entity/schema                       fund/schema
     :entity/synced?                      true
     :entity/icon                         :fa-hand-holding-seedling
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions entity]}]
       (let [account-funds (:account-access-to-funds account-current-permissions)
             account-teams (:account-team-memberships account-current-permissions)]
         (boolean
          (or (contains? account-funds (eid/eid entity))
              (->> entity
                   :fund/teams
                   (cu/find-first
                    (fn [team-id]
                      (contains? account-teams team-id))
                    (comp
                     (remove :common/disabled?)
                     (keep eid/eid))))))))
     :entity/disable-permissions-check-fn admin-delete-check-fn}

    :entity.type/fund-commitment
    {:entity/schema      fund-commitment/schema
     :entity/icon        :fa-money-check-edit-alt
     :entity/create-icon :fa-money-check-edit-alt
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions entity] :as ctx}]
        ;; fundraising or
        ;; member of team linked to the fundraising oppo - the commitment was created from
        ;; or your are membr of team linked to the fund
       (let [account-modules (:account-modules account-current-permissions)]
         (or
          (contains? account-modules :module/fundraising)
          (contains? account-modules :module/portfolio)
          ;; TODO VERIFY RULES
          (->> entity
               :fundraising-opportunity/_fund-commitment
               (remove :common/disabled?)
               (some (fn [fo]
                       (read-permissions? (assoc ctx :entity fo)))))
          (contains? (:account-access-to-funds account-current-permissions)
                     (->> entity
                          :fund-commitment/fund
                          :db/id))
          (let [originated-froppo (->> entity
                                       :fundraising-opportunity/_fund-commitment
                                       (remove :common/disabled?)
                                       (first))]
            (contains? (:account-access-to-pipelines account-current-permissions)
                       (->> originated-froppo
                            :fundraising-opportunity/pipeline
                            :db/id))))))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                      ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                     (has-write-permissions? entity))
         (tr :not-allowed)))}

    :entity.type/fundraising-opportunity
    {:entity/schema      fundraising-opportunity/schema
     :entity/icon        :fa-funnel-dollar
     :entity/create-icon :fa-hand-holding-seedling
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions entity]}]
       (and (contains? (:account-modules account-current-permissions)
                       :module/fundraising)
            (contains? (:account-access-to-pipelines account-current-permissions)
                       (->> entity
                            :fundraising-opportunity/pipeline
                            :db/id))))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                      ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                     (has-write-permissions? entity))
         (tr :not-allowed)))}

    :entity.type/sales-opportunity
    {:entity/schema      sales-opportunity/schema
     :entity/icon        :fa-search-dollar
     :entity/create-icon :fa-bullseye-pointer
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions entity]}]
       (and (contains? (:account-modules account-current-permissions)
                       :module/sales-pipelines)
            (contains? (:account-access-to-pipelines account-current-permissions)
                       (->> entity
                            :sales-opportunity/pipeline
                            :db/id))))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                      ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                     (has-write-permissions? entity))
         (tr :not-allowed)))}

    :entity.type/sales-opportunity-stage
    {:entity/schema                       sales-opportunity-stage/schema
     :entity/synced?                      true
     :entity/icon                         :fa-search-dollar
     :entity/custom-sort                  true
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions]}]
       (contains? (:account-modules account-current-permissions)
                  :module/sales-pipelines))
     :entity/disable-permissions-check-fn dedicated-delete-should-be-used-fn}
    :entity.type/exit-opportunity
    {:entity/schema                    exit-opportunity/schema
     :entity/icon                      :fa-search-dollar
     :entity/create-icon               :fa-door-open
     :entity/read-permissions-check-fn exit-oppo-read-check-fn

     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                      ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                     (has-write-permissions? entity))
         (tr :not-allowed)))}

    :entity.type/exit-opportunity-stage
    {:entity/schema                       exit-opportunity-stage/schema
     :entity/synced?                      true
     :entity/icon                         :fa-search-dollar
     :entity/custom-sort                  true
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions]}]
       (contains? (:account-modules account-current-permissions)
                  :module/exit-process-management))
     :entity/disable-permissions-check-fn dedicated-delete-should-be-used-fn}

    :entity.type/sale-agreement
    {:entity/schema      sale-agreement/schema
     :entity/icon        :fa-file-signature
     :entity/create-icon :fa-file-signature
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions]}]
        ;; has sales-pipeline access to the pipeline deal was made from
        ;; TODO ?? OR what
        ;; TODO: where do we save oppo -> holding info?
       (contains? (:account-modules account-current-permissions)
                  :module/sales-pipelines))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                      ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                     (has-write-permissions? entity))
         (tr :not-allowed)))}
    :entity.type/holding
    {:entity/schema      holding/schema
     :entity/icon        :fa-briefcase
     :entity/create-icon :fa-briefcase
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions]}]
        ;; has portfolio module or access to the pipeline deal was made from
        ;; TODO: where do we save oppo -> holding info?
       (contains? (:account-modules account-current-permissions)
                  :module/portfolio))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (cond
         (not (or (roles/admin? role)
                   ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                  (has-write-permissions? entity)))
         (tr :not-allowed)

         (->> entity
              :exit-opportunity/_target-holding
              (remove :common/disabled?)
              (seq))
         (tr :cannot-delete-holding-when-target-in-exit-oppo)))}
    :entity.type/import-data
    {:entity/schema                       import-data/schema
     :entity/icon                         :fa-file-import
     :entity/read-permissions-check-fn
     (fn [{:keys []}]
       true)
     :entity/disable-permissions-check-fn admin-delete-check-fn}

    :entity.type/investor
    {:entity/schema      investor/schema
     :entity/icon        :fa-user-tie
     :entity/create-icon :fa-user-tie
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions] :as _ctx}]
        ;; has acceess to fundraising module
        ;; or has access to froppro linked to this investor
        ;; TODO - double check if investors are available for all TU's
       #_{:clj-kondo/ignore [:single-logical-operand]}
       (or
        (contains? (:account-modules account-current-permissions)
                   :module/fundraising)
          ;; leaving commented version for future
        #_(let [pipeline-ids-set (some->> candidate
                                          :fundraising-opportunity/_investor
                                          (map :fundraising-opportunity/pipeline)
                                          (map :db/id)
                                          (set))]
            (some pipeline-ids-set (:account-access-to-pipelines account-current-permissions)))))
     :entity/disable-permissions-check-fn
     (fn [{:keys [entity tr] :as ctx}]
       (or (crm-delete-check-fn ctx)
           (cond
             (->> entity
                  :exit-opportunity/_buyer
                  (remove :common/disabled?)
                  (seq))
             (tr :cannot-delete-when-buyer-candidate-in-exit-opportunities))))}
    :entity.type/job
    {:entity/schema                       job/schema
     :entity/icon                         :fa-business-time
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                            true)
     :entity/disable-permissions-check-fn system-controlled-entity-delete-check}
    :entity.type/kpi-category
    {:entity/schema                       kpi-category/schema
     :entity/icon                         :fa-chart-line
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions role tenant]}]
       (or (contains? (:account-modules account-current-permissions)
                      :module/kpi-reporting)
           (and (= role :role/guest-sell-side)
                (contains? (set (:tenant/modules tenant))
                           :module/kpi-reporting))))
     :entity/disable-permissions-check-fn dedicated-delete-should-be-used-fn}

    :entity.type/kpi-report-data
    {:entity/schema                       kpi-report-data/schema
     :entity/icon                         :fa-user-chart
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions role account entity]}]
       (if (= role :role/guest-sell-side)
         (some #{(:db/id account)}
               (->> entity
                    :kpi-report-data/kpi-report
                    :kpi-report/company
                    :role/_target
                    (remove :common/disabled?)
                    (map :role/subject)
                    (keep :db/id)))
         (contains? (:account-modules account-current-permissions)
                    :module/kpi-reporting)))
     :entity/disable-permissions-check-fn dedicated-delete-should-be-used-fn}

    :entity.type/kpi-report-answer
    {:entity/schema                       kpi-report-answer/schema
     :entity/icon                         :fa-user-chart
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions role account entity]}]
       (if (= role :role/guest-sell-side)
         (some #{(:db/id account)}
               (->> entity
                    :kpi-report-answer/kpi-report
                    :kpi-report/company
                    :role/_target
                    (remove :common/disabled?)
                    (map :role/subject)
                    (keep :db/id)))
         (contains? (:account-modules account-current-permissions)
                    :module/kpi-reporting)))
     :entity/disable-permissions-check-fn dedicated-delete-should-be-used-fn}

    :entity.type/kpi-report
    {:entity/schema                       kpi-report/schema
     :entity/icon                         :fa-user-chart
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions role account entity]}]
       (if (= role :role/guest-sell-side)
         (some #{(:db/id account)}
               (->> entity
                    :kpi-report/company
                    :role/_target
                    (remove :common/disabled?)
                    (map :role/subject)
                    (keep :db/id)))
         (contains? (:account-modules account-current-permissions)
                    :module/kpi-reporting)))
     :entity/disable-permissions-check-fn dedicated-delete-should-be-used-fn}

    :entity.type/kpi-cycle
    {:entity/schema kpi-cycle/schema
     :entity/icon   :fa-recycle
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions role tenant]}]
       (or (contains? (:account-modules account-current-permissions)
                      :module/kpi-reporting)
           (and (= role :role/guest-sell-side)
                (contains? (set (:tenant/modules tenant))
                           :module/kpi-reporting))))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr entity] :as ctx}]
       (or (kpi-delete-check-fn ctx)
           (when (->> entity
                      :kpi-report/_kpi-cycle
                      (remove :common/disabled?)
                      (seq))
             (tr :kpi-cycle-cannot-be-deleted-with-active-reports))))}

    :entity.type/kpi-member
    {:entity/schema                       kpi-member/schema
     :entity/icon                         :fa-user-cog
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions role account entity]}]
       (if (= role :role/guest-sell-side)
         (some #{(:db/id account)}
               (->> entity
                    :kpi-member/asset
                    :role/_target
                    (remove :common/disabled?)
                    (map :role/subject)
                    (keep :db/id)))
         (contains? (:account-modules account-current-permissions)
                    :module/kpi-reporting)))
     :entity/disable-permissions-check-fn kpi-delete-check-fn}

    :entity.type/named-value
    {:entity/schema                       named-value/schema
     :entity/synced?                      false
     :entity/icon                         :fa-hand-holding-usd
     :entity/custom-sort                  true
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                            true)
     :entity/disable-permissions-check-fn admin-delete-check-fn}

    :entity.type/note
    {:entity/schema                       note/new-note
     :entity/icon                         :fa-edit
     :entity/read-permissions-check-fn
     (fn [{:keys []}]
        ;; TODO - do we need to check if you have access to target entities ??
       true)
     :entity/disable-permissions-check-fn activity-delete-check-fn}

    :entity.type/note-call
    {:entity/schema                       note-call/new-call
     :entity/icon                         :fa-phone
     :entity/read-permissions-check-fn
     (fn [{:keys []}]
        ;; TODO - do we need to check if you have access to target entities ??
       true)
     :entity/disable-permissions-check-fn activity-delete-check-fn}

    :entity.type/note-meeting
    {:entity/schema                       note-meeting/new-meeting
     :entity/icon                         :fa-users
     :entity/read-permissions-check-fn
     (fn [{:keys []}]
        ;; TODO - do we need to check if you have access to target entities ??
       true)
     :entity/disable-permissions-check-fn activity-delete-check-fn}

    :entity.type/note-message
    {:entity/schema                       note-message/new-message
     :entity/icon                         :fa-comments
     :entity/read-permissions-check-fn
     (fn [{:keys []}]
        ;; TODO - do we need to check if you have access to target entities ??
       true)
     :entity/disable-permissions-check-fn activity-delete-check-fn}

    :entity.type/oppo
    {:entity/schema                    oppo/schema
     :entity/icon                      :fa-handshake
     :entity/create-icon               :fa-file-plus
     :entity/read-permissions-check-fn oppo-read-check-fn
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                      ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                     (has-write-permissions? entity))
         (tr :not-allowed)))}

    :entity.type/opportunity-stage
    {:entity/schema                       opportunity-stage/schema
     :entity/synced?                      true
     :entity/icon                         :fa-lightbulb-on
     :entity/custom-sort                  true
     :entity/read-permissions-check-fn
     (fn [{:keys []}]
       true)
     :entity/disable-permissions-check-fn dedicated-delete-should-be-used-fn}

    :entity.type/other-asset
    {:entity/schema                       other-asset/schema
     :entity/icon                         :fa-dna
     :entity/create-icon                  :fa-dna
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                            true)
     :entity/disable-permissions-check-fn crm-delete-check-fn}

    :entity.type/person
    {:entity/schema                       person/schema
     :entity/icon                         :fa-user
     :entity/create-icon                  :fa-user-plus
     :entity/read-permissions-check-fn
     (fn [{:keys []}]
       true)
     :entity/disable-permissions-check-fn crm-delete-check-fn}

    :entity.type/pipeline
    {:entity/schema                       pipeline/schema
     :entity/synced?                      true
     :entity/icon                         :fa-stream
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions entity]}]
       (let [account-pipelines (:account-access-to-pipelines account-current-permissions)
             account-teams (:account-team-memberships account-current-permissions)]
         (boolean
          (or (contains? account-pipelines (eid/eid entity))
              (->> entity
                   :pipeline/teams
                   (cu/find-first
                    (fn [team-id]
                      (contains? account-teams team-id))
                    (comp
                     (remove :common/disabled?)
                     (keep eid/eid))))))))
     :entity/disable-permissions-check-fn admin-delete-check-fn}

    :entity.type/real-estate
    {:entity/schema                       real-estate/schema
     :entity/icon                         :fa-house
     :entity/create-icon                  :fa-house
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                            true)
     :entity/disable-permissions-check-fn crm-delete-check-fn}
    :entity.type/stage
    {:entity/schema                       stage/schema
     :entity/synced?                      true
     :entity/icon                         :fa-sliders-h
     :entity/custom-sort                  true
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                            true)
     :entity/disable-permissions-check-fn dedicated-delete-should-be-used-fn}

    :entity.type/system-activity
    {:entity/schema                       system-activity/schema
     :entity/icon                         :fa-file-chart-line
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                            true)
     :entity/disable-permissions-check-fn system-controlled-entity-delete-check}

    :entity.type/task
    {:entity/schema                       task/schema
     :entity/icon                         :fa-tasks
     :entity/read-permissions-check-fn
     (fn [{:keys [account tenant entity]}]
       (or (not (= "CapMan" (:tenant/name tenant)))
           (= (:db/id account)
              (->> entity
                   :task/assignee
                   :db/id))))
     :entity/disable-permissions-check-fn (fn [{:keys [tr entity account] :as ctx}]
                                            (when-not (or (owner-admin-check-fn ctx)
                                                          (->> entity
                                                               :task/assignee
                                                               :db/id
                                                               (= (:db/id account)))
                                                          (->> entity
                                                               :common/team-members
                                                               (map :db/id)
                                                               (some #{(:db/id account)})))
                                              (tr :only-admin-or-assignee-can-delete-tasks)))}

    :entity.type/named-view
    {:entity/schema                            named-view-schema/schema
     :entity/read-permissions-check-fn         owner-admin-check-fn
     :entity/icon                              :fa-eye
     :entity/disable-permissions-check-fn      owner-admin-delete-check-fn
     :entity/can-be-created-by-read-only-user? true
     :entity/synced?                           true}

    :entity.type/graph-config
    {:entity/read-permissions-check-fn
      ;; everyone with entity-graph can see all configs:
     entity-graph-access?
     :entity/icon
     :fa-eye
     :entity/disable-permissions-check-fn
     owner-admin-delete-check-fn
     :entity/can-be-created-by-read-only-user?
     false
     :entity/synced?
     true}

    :entity.type/team
    {:entity/schema                       team/schema
     :entity/synced?                      true
     :entity/icon                         :fa-users
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions account-id entity]}]
       (let [account-teams (:account-team-memberships account-current-permissions)
             entity-id (:db/id entity)]
         (boolean
          (or (contains? account-teams entity-id)
              (->> entity
                   :team/members
                   (cu/find-first
                    (fn [team-member]
                      (= (eid/eid team-member)
                         account-id))))))))
     :entity/disable-permissions-check-fn (fn [{:keys [tr entity] :as ctx}]
                                            (or (admin-delete-check-fn ctx)
                                                (when (->> entity
                                                           :team/members
                                                           (seq))
                                                  (tr :cannot-delete-team-with-members))))}
    :entity.type/tenant
    {:entity/schema                       tenant/schema
     :entity/synced?                      true
     :entity/icon                         :fa-user
     :entity/read-permissions-check-fn
     (fn [{:keys []}]
       true)
     :entity/disable-permissions-check-fn dedicated-delete-should-be-used-fn}

    :entity.type/login-page-config
    {:entity/schema                       login-page-config/schema
     :entity/icon                         :fa-sign-in-alt
     :entity/read-permissions-check-fn    (fn [{:keys [tenant role]}]
                                            (and (plan/available :feature/new-sso-2025 tenant)
                                                 (roles/admin? role)))
     :entity/disable-permissions-check-fn admin-delete-check-fn}
    :entity.type/token
    {:entity/schema                       token/schema
     :entity/icon                         :fa-coin
     :entity/read-permissions-check-fn
     (fn [{:keys []}]
       true)
     :entity/disable-permissions-check-fn system-controlled-entity-delete-check}

    :entity.type/ribbon
    {:entity/schema                       ribbon/schema
     :entity/synced?                      true
     :entity/read-permissions-check-fn    (fn [{:keys [entity account]}]
                                             ;; TODO: add more
                                            (entity-ownership/entity-owner? account entity))
     :entity/disable-permissions-check-fn (fn [{:keys [tr account entity]}]
                                             ;; TODO: add more
                                            (when-not (entity-ownership/entity-owner? account entity)
                                              (tr :only-owner-can-delete-ribbon)))}
    :entity.type/tab
    {:entity/schema                       tab/schema
     :entity/synced?                      true
     :entity/read-permissions-check-fn    (fn [{:keys [entity account]}]
                                             ;; TODO: add more
                                            (entity-ownership/entity-owner? account entity))
     :entity/disable-permissions-check-fn (fn [{:keys [tr entity account]}]
                                             ;; TODO: add more
                                            (when-not (entity-ownership/entity-owner? account entity)
                                              (tr :only-owner-can-delete-tab)))}

    :entity.type/view
    {:entity/schema                       view/schema
     :entity/synced?                      true
     :entity/icon                         :fa-eye
     :entity/read-permissions-check-fn    (fn [{:keys [entity account account-current-permissions]}]
                                            (view/has-read-access? account
                                                                   account-current-permissions
                                                                   entity))
     :entity/disable-permissions-check-fn (fn [{:keys [tr account entity]}]
                                            (when-not (view/view-owner? account entity)
                                              (tr :only-owner-can-delete-view)))}

    :entity.type/card
    {:entity/schema                       card/schema
     :entity/synced?                      true
     :entity/read-permissions-check-fn    (fn [{:keys [entity account account-current-permissions]}]
                                            (or (card/has-read-access? account account-current-permissions entity)
                                                (->> entity
                                                     :view/_cards
                                                     (cu/remove-by :common/disabled? true)
                                                     (some (fn [view-entity]
                                                             (view/has-read-access? account
                                                                                    account-current-permissions
                                                                                    view-entity))))))

     :entity/disable-permissions-check-fn (fn [{:keys [tr entity account]}]
                                            (when-not (card/card-owner? account entity)
                                              (tr :only-owner-can-delete-card)))}

    :entity.type/volume-data
    {:entity/schema                       volume-data/schema
     :entity/icon                         :fa-database
     :entity/read-permissions-check-fn
     (fn [{:keys []}]
       true)
     :entity/disable-permissions-check-fn system-controlled-entity-delete-check}

    :entity.type/webentry
    {:entity/schema                       webentry/schema
     :entity/icon                         :fa-atlas
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                            true)
     :entity/disable-permissions-check-fn admin-delete-check-fn}

    :entity.type/attachment
    {:entity/schema                       attachment/schema
     :entity/icon                         :fa-paperclip
     :entity/read-permissions-check-fn
     (fn [{:keys []}]
        ;;TODO: implement attachment permission check!
       true)
     :entity/disable-permissions-check-fn attachment-delete-check-fn}
    :entity.type/workspace
    {:entity/schema                       workspace/schema
     :entity/icon                         :fa-users-class
     :entity/read-permissions-check-fn    (fn [{:keys [account entity]}]
                                            (->> account
                                                 :role/_subject
                                                 (some (fn [r]
                                                         (= (->> r
                                                                 :role/target
                                                                 :db/id)
                                                            (->> entity
                                                                 :db/id))))))
     :entity/disable-permissions-check-fn owner-admin-delete-check-fn}

    :entity.type/workspace-team
    {:entity/schema                       workspace-team/schema
     :entity/icon                         :fa-users-class
     :entity/read-permissions-check-fn    (fn [{:keys [account entity]}]
                                            (->> account
                                                 :role/_subject
                                                 (some (fn [r]
                                                         (= (->> r
                                                                 :role/target
                                                                 :db/id)
                                                            (->> entity
                                                                 :workspace-team/workspace
                                                                 :db/id))))))
     :entity/disable-permissions-check-fn admin-delete-check-fn}

    :entity.type/tenant-kyc-profile
    {:entity/schema tenant-kyc-profile/schema
     :entity/icon   :fa-shield-check
     :entity/mcp-blacklisted? true
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions tenant role tenant-plan]}]
       (and (plan/available :feature/tenant-kyc tenant role tenant-plan)
            (contains? (:account-modules account-current-permissions)
                       :module/tenant-kyc)))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                      ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                     (has-write-permissions? entity))
         (tr :not-allowed)))}

    :entity.type/contract-kyc-profile
    {:entity/schema contract-kyc-profile/schema
     :entity/icon   :fa-shield-check
     :entity/mcp-blacklisted? true
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions tenant role tenant-plan]}]
       (and (plan/available :feature/contract-kyc tenant role tenant-plan)
            (contains? (:account-modules account-current-permissions)
                       :module/contract-kyc)))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                      ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                     (has-write-permissions? entity))
         (tr :not-allowed)))}

    :entity.type/survey-type
    {:entity/schema survey-type/schema
     :entity/icon   :fa-shield-check
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions account entity tenant role tenant-plan]}]
       (let [survey-type-team-ids (some->> entity
                                           :survey-type/teams-access
                                           (map (fn [t]
                                                  (if (number? t)
                                                    t
                                                    (:db/id t)))))
             account-membership-team-ids (some->> account
                                                  :team/_members
                                                  (map :db/id))]
         (and (plan/available :feature/surveys tenant role tenant-plan)
              (contains? (:account-modules account-current-permissions)
                         :module/survey)
              (or (contains? (:account-modules account-current-permissions)
                             :module/surveys-admin)
                  (roles/admin? role)
                  (some (set survey-type-team-ids) account-membership-team-ids)))))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                      ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                     (has-write-permissions? entity))
         (tr :not-allowed)))}
    :entity.type/rotation-period
    {:entity/schema rotation-period/schema
     :entity/icon   :fa-repeat
     :entity/read-permissions-check-fn
     (fn [{:keys [tenant role tenant-plan account-current-permissions]}]
       (and (plan/available :feature/surveys tenant role tenant-plan)
            (contains? (:account-modules account-current-permissions)
                       :module/survey)))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                     (has-write-permissions? entity))
         (tr :not-allowed)))}
    :entity.type/rotation-period-override
    {:entity/schema rotation-period-override/schema
     :entity/icon   :fa-code-branch
     :entity/read-permissions-check-fn
     (fn [{:keys [tenant role tenant-plan account-current-permissions]}]
       (and (plan/available :feature/surveys tenant role tenant-plan)
            (contains? (:account-modules account-current-permissions)
                       :module/survey)))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                     (has-write-permissions? entity))
         (tr :not-allowed)))}
    :entity.type/survey-template
    {:entity/schema survey-template/schema
     :entity/icon   :fa-shield-check
     :entity/read-permissions-check-fn
     (fn [{:keys [tenant role tenant-plan]}]
       (plan/available :feature/surveys tenant role tenant-plan))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                      ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                     (has-write-permissions? entity))
         (tr :not-allowed)))}
    :entity.type/survey-block
    {:entity/schema survey-block/schema
     :entity/icon   :fa-th
     :entity/read-permissions-check-fn
     (fn [{:keys [tenant role tenant-plan]}]
       (plan/available :feature/surveys tenant role tenant-plan))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                      ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                     (has-write-permissions? entity))
         (tr :not-allowed)))}
    :entity.type/survey-answer
    {:entity/schema survey-answer/schema
     :entity/icon   :fa-check
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions tenant role tenant-plan]}]
       (and (plan/available :feature/surveys tenant role tenant-plan)
            (contains? (:account-modules account-current-permissions)
                       :module/survey)))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                      ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                     (has-write-permissions? entity))
         (tr :not-allowed)))}
    :entity.type/survey-question-option
    {:entity/schema survey-question-option/schema
     :entity/icon   :fa-question-square
     :entity/read-permissions-check-fn
     (fn [{:keys [tenant role tenant-plan]}]
       (plan/available :feature/surveys tenant role tenant-plan))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                      ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                     (has-write-permissions? entity))
         (tr :not-allowed)))}
    :entity.type/survey-question-ext-id
    {:entity/schema survey-question-external-id/schema
     :entity/icon   :fa-id-card
     :entity/read-permissions-check-fn
     (fn [{:keys [tenant role tenant-plan]}]
       (plan/available :feature/surveys tenant role tenant-plan))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                      ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                     (has-write-permissions? entity))
         (tr :not-allowed)))}
    :entity.type/survey-profile
    {:entity/schema survey-profile/schema
     :entity/icon   :fa-clipboard-list
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions tenant role tenant-plan]}]
       (and (plan/available :feature/surveys tenant role tenant-plan)
            (contains? (:account-modules account-current-permissions)
                       :module/survey)))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                      ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                     (has-write-permissions? entity))
         (tr :not-allowed)))}
    :entity.type/survey-cycle
    {:entity/schema survey-cycle/schema
     :entity/icon   :fa-calendar
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions tenant role tenant-plan]}]
       (and (plan/available :feature/surveys tenant role tenant-plan)
            (contains? (:account-modules account-current-permissions)
                       :module/survey)))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                     (has-write-permissions? entity))
         (tr :not-allowed)))}
    :entity.type/survey-batch
    {:entity/schema survey-batch/schema
     :entity/icon   :fa-layer-group
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions tenant role tenant-plan]}]
       (and (plan/available :feature/surveys tenant role tenant-plan)
            (contains? (:account-modules account-current-permissions)
                       :module/survey)))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                     (has-write-permissions? entity))
         (tr :not-allowed)))}
    :entity.type/kyc-process
    {:entity/schema kyc-process/schema
     :entity/icon   :fa-clipboard-list
     :entity/mcp-blacklisted? true
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions account entity tenant role tenant-plan]}]
       (let [containing-entity-type (:kyc-process/containing-entity-type entity)
             account-modules (:account-modules account-current-permissions)
             required-plan-and-module? (case containing-entity-type
                                         :entity.type/tenant-kyc-profile
                                         (and (plan/available :feature/tenant-kyc tenant role tenant-plan)
                                              (contains? account-modules
                                                         :module/tenant-kyc))

                                         :entity.type/contract-kyc-profile
                                         (and (plan/available :feature/contract-kyc tenant role tenant-plan)
                                              (contains? account-modules
                                                         :module/contract-kyc))

                                         :entity.type/kyc-profile
                                         (and (plan/available :feature/kyc tenant role tenant-plan)
                                              (contains? account-modules
                                                         :module/kyc))

                                         (do
                                           #?(:clj (println "Unknown kyc process containing entity type: " containing-entity-type))
                                           false))]
         (or required-plan-and-module?
             (->> account
                  :role/_subject
                  (remove :common/disabled?)
                  (map :role/target)
                  (cu/only-entity :entity.type/workspace)
                  (map :workspace/target)
                  (map :db/id)
                  (set)
                  (some #{(:db/id entity)})))))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                      ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                     (has-write-permissions? entity))
         (tr :not-allowed)))}
    :entity.type/survey-process
    {:entity/schema survey-process/schema
     :entity/icon   :fa-shield-check
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions account entity tenant role tenant-plan]}]
       (or (and (plan/available :feature/surveys tenant role tenant-plan)
                (contains? (:account-modules account-current-permissions)
                           :module/survey))
           (->> account
                :role/_subject
                (remove :common/disabled?)
                (map :role/target)
                (cu/only-entity :entity.type/workspace)
                (map :workspace/target)
                (map :db/id)
                (set)
                (some #{(:db/id entity)}))))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                      ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                     (has-write-permissions? entity))
         (tr :not-allowed)))}
    :entity.type/kyc-risk-category
    {:entity/schema kyc-risk-category/schema
     :entity/icon   :fa-shield-check
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions tenant role tenant-plan]}]
       (and (plan/available :feature/kyc tenant role tenant-plan)
            (contains? (:account-modules account-current-permissions)
                       :module/kyc)))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                      ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                     (has-write-permissions? entity))
         (tr :not-allowed)))}
    :entity.type/reminder-rule
    {:entity/schema reminder-rule/schema
     :entity/icon   :fa-bell
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions tenant role tenant-plan]}]
       (and (plan/available :feature/surveys tenant role tenant-plan)
            (contains? (:account-modules account-current-permissions)
                       :module/survey)))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                     (has-write-permissions? entity))
         (tr :not-allowed)))}
    :entity.type/survey-reminder
    {:entity/schema survey-reminder/schema
     :entity/icon   :fa-bell
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions tenant role tenant-plan]}]
       (and (plan/available :feature/surveys tenant role tenant-plan)
            (contains? (:account-modules account-current-permissions)
                       :module/survey)))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                     (has-write-permissions? entity))
         (tr :not-allowed)))}
    :entity.type/lp-report
    {:entity/schema      lp-report/schema
     :entity/icon        :fa-file-chart-line
     :entity/create-icon :fa-file-chart-line
     :entity/read-permissions-check-fn
     (fn [{:keys [role account-current-permissions entity tenant account tenant-plan]}]
       (let [report entity
             user-email (cu/str-trim-lcase (:account/email account))
             fund (:lp-report/fund report)]
         (and
          (plan/available :feature/lp-reporting tenant role tenant-plan)
          (or
           (roles/admin? role)
           (and (contains? (:account-modules account-current-permissions)
                           :module/lp-reporting)
                (some (set/union (->> (:fund/teams fund)
                                      (map eid/eid)
                                      (set))
                                 (->> (:fund/reporting-admins fund)
                                      (map eid/eid)
                                      (set)))
                      (:account-team-memberships account-current-permissions)))
           (and
            (= role :role/guest-lp-portal)
            (or
             (roles/admin? role)
             (and (some #{:module/lp-reporting} (:account-modules account-current-permissions))
                  (some (set/union (->> (:fund/teams fund)
                                        (map eid/eid)
                                        (set))
                                   (->> (:fund/reporting-admins fund)
                                        (map eid/eid)
                                        (set)))
                        (:account-team-memberships account-current-permissions)))
             (and
              (= role :role/guest-lp-portal)
              (or
               (->> fund
                    :fund-commitment/_fund
                    (remove :common/disabled?)
                    (filter
                     (fn [fc]
                       (->> fc
                            :common/related-entities
                            (cu/only-entity :entity.type/entity-association)
                            (cu/filter-by :entity-association/type
                                          :association.type/reporting-contact)
                            (keep
                             (fn [ea]
                               (if (= (:db/id fc) (:db/id (:entity-association/target-entity ea)))
                                 (:entity-association/source-entity ea)
                                 (:entity-association/target-entity ea))))
                            (filter (fn [p]
                                      (= (cu/str-trim-lcase (:person/universal-email-address p))
                                         user-email)))
                            (seq))))
                       ;; has accessible commitments
                    (seq))
               (->> fund
                    :fund/_feeder-fund-to
                    (filter
                     (fn [feeder]
                       (->> feeder
                            :fund-commitment/_fund
                            (remove :common/disabled?)
                            (filter
                             (fn [fc]
                               (->> fc
                                    :common/related-entities
                                    (cu/only-entity :entity.type/entity-association)
                                    (cu/filter-by :entity-association/type
                                                  :association.type/reporting-contact)
                                    (keep
                                     (fn [ea]
                                       (if (= (:db/id fc) (:db/id (:entity-association/target-entity ea)))
                                         (:entity-association/source-entity ea)
                                         (:entity-association/target-entity ea))))
                                    (filter (fn [p]
                                              (= (cu/str-trim-lcase (:person/universal-email-address p))
                                                 user-email)))
                                    (seq))))
                                ;; has accessible commitments to feeder
                            (seq))))
                    (seq))
               (->> fund
                    :common/related-entities
                    (cu/only-entity :entity.type/entity-association)
                    (cu/filter-by :entity-association/type :association.type/external-report-access)
                    (keep (fn [ea]
                            (if (= (:db/id fund) (:db/id (:entity-association/target-entity ea)))
                              (:entity-association/source-entity ea)
                              (:entity-association/target-entity ea))))
                    (filter (fn [p]
                              (= (cu/str-trim-lcase (:person/universal-email-address p))
                                 user-email)))
                       ;; has accessible funds
                    (seq))
               (->> fund
                    :fund/_feeder-fund-to
                    (filter (fn [feeder]
                              (->> feeder
                                   :common/related-entities
                                   (cu/only-entity :entity.type/entity-association)
                                   (cu/filter-by :entity-association/type :association.type/external-report-access)
                                   (keep (fn [ea]
                                           (if (= (:db/id fund) (:db/id (:entity-association/target-entity ea)))
                                             (:entity-association/source-entity ea)
                                             (:entity-association/target-entity ea))))
                                   (filter (fn [p]
                                             (= (cu/str-trim-lcase (:person/universal-email-address p))
                                                user-email)))
                                      ;; has accessible feeder funds
                                   (seq))))
                    (seq))))))))))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role account entity]}]
       (when-not (or (roles/admin? role)
                     (some #{(:db/id account)}
                           (->> (:lp-report/process-owners entity)
                                (map :db/id)))
                     (some #{(:db/id account)}
                           (->> (:lp-report/fund entity)
                                :fund/reporting-admins
                                (mapcat :team/members)
                                (map :db/id))))
         (tr :not-allowed)))}
    :entity.type/lp-report-holding
    {:entity/schema                       lp-report-holding/schema
     :entity/icon                         :fa-chart-bar
     :entity/create-icon                  :fa-plus-circle
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions tenant role tenant-plan]}]
       (and (plan/available :feature/lp-reporting tenant role tenant-plan)
            (contains? (:account-modules account-current-permissions)
                       :module/lp-reporting)))
     :entity/disable-permissions-check-fn (fn [{:keys [tr role entity has-write-permissions?]}]
                                            (when-not (or (roles/admin? role)
                                                           ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                                                          (has-write-permissions? entity))
                                              (tr :not-allowed)))}
    :entity.type/lp-report-investor-commitment
    {:entity/schema                       lp-report-investor-commitment/schema
     :entity/icon                         :fa-money-check-edit-alt
     :entity/create-icon                  :fa-plus-circle
     :entity/read-permissions-check-fn
     (fn [{:keys []}]
       #_(and (plan/available :feature/lp-reporting tenant)
              (some #{:module/lp-reporting} (:account-modules account-current-permissions)))
       true)
     :entity/disable-permissions-check-fn (fn [{:keys [tr role entity has-write-permissions?]}]
                                            (when-not (or (roles/admin? role)
                                                           ;; TODO: we need explicit delete permissions to be configured for non activity entity types
                                                          (has-write-permissions? entity))
                                              (tr :not-allowed)))}
    :entity.type/calculated-indirect-holding
    {:entity/schema                       indirect-holding/schema
     :entity/icon                         :fa-briefcase
     :entity/calculated?                  true
     :entity/create-icon                  :fa-briefcase
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions]}]
        ;; has portfolio module or access to the pipeline deal was made from
        ;; TODO: where do we save oppo -> holding info?
       (contains? (:account-modules account-current-permissions)
                  :module/portfolio))
     :entity/disable-permissions-check-fn calculated-entity-delete-check-fn}

    :entity.type/feedback
    {:entity/schema                            feedback/schema
     :entity/icon                              :fa-comment-alt-lines
     :entity/read-permissions-check-fn
     (fn [{:keys [account entity]}]
       (= (:db/id account) (:db/id (:common/owner entity))))
     :entity/disable-permissions-check-fn      system-controlled-entity-delete-check
     :entity/can-be-created-by-read-only-user? true}

    :entity.type/scheduled-job
    {:entity/schema scheduled-job/schema
     :entity/icon   :fa-edit
     :entity/read-permissions-check-fn
     (fn [{:keys []}]
       false)
     :entity/disable-permissions-check-fn
     delete-not-allowed!}

    :entity.type/screening-profile
    {:entity/schema        screening-profile-schema/schema
     :entity/icon          :fa-edit
     :entity/search-index? true
     :entity/mcp-read-permissions-check-fn
     (fn [{:keys [role]}]
       (roles/admin? role))
     :entity/read-permissions-check-fn
     (fn [{:keys [account-current-permissions tenant role tenant-plan]}]
       (and (plan/available :feature/screening tenant role tenant-plan)
            (contains? (:account-modules account-current-permissions)
                       :module/screening)))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role entity has-write-permissions?]}]
       (when-not (or (roles/admin? role)
                     (has-write-permissions? entity))
         (tr :not-allowed)))}

    :creatable-entity-types
    {:entity/schema                       entity-schema/schema
     :entity/icon                         :fa-folder-tree
     :entity/read-permissions-check-fn
     (fn [{:keys []}]
       true)
     :entity/disable-permissions-check-fn abstract-entity-delete-check-fn}

    :tenant-inbox
    {:entity/schema tenant-inbox/schema
     :entity/icon   :fa-inbox}
    :asset
    {:entity/schema asset/schema
     :entity/icon   :fa-hand-holding-usd}
    :common
    {:entity/schema common/schema
     :entity/icon   :fa-draw-circle}
    :deal-contact-association
    {:entity/schema entity-association/deal-contact-schema
     :entity/icon   :fa-handshake-alt}
    :investor-contact-association
    {:entity/schema entity-association/investor-contact-schema
     :entity/icon   :fa-hand-holding-seedling}
    :froppo-contact-association
    {:entity/schema entity-association/froppo-contact-schema
     :entity/icon   :fa-id-card}
    :holding-contact-association
    {:entity/schema entity-association/holding-contact-schema
     :entity/icon   :fa-id-card}
    :company-contact-association
    {:entity/schema entity-association/company-contact-schema
     :entity/icon   :fa-id-card}
    :fof-asset-contact-association
    {:entity/schema entity-association/fof-asset-contact-schema
     :entity/icon   :fa-seedling}
    :existing-email
    {:entity/schema email/edit-email
     :entity/icon   :fa-envelope}
    :related-entities
    {:entity/schema related-entities/related-entities
     :entity/icon   :fa-id-card}
    :role
    {:entity/schema role/role-schema
     :entity/icon   :fa-user-check}

    :entity.type/role
    {:entity/disable-permissions-check-fn dedicated-delete-should-be-used-fn
     :entity/icon                         :fa-user-check
     :entity/synced?                      true}

    :entity.type/cached-report
    {:entity/icon                         :fa-file-chart-line
     :entity/disable-permissions-check-fn admin-delete-check-fn}

    :entity.type/involvement
    {:entity/disable-permissions-check-fn admin-delete-check-fn
     :entity/icon                         :fa-hands}

    :entity.type/stage-volume-data
    {:entity/icon                         :fa-database
     :entity/disable-permissions-check-fn system-controlled-entity-delete-check}

    :entity.type/account
    {:entity/disable-permissions-check-fn system-controlled-entity-delete-check
     :entity/schema                       account-schema/schema
     :entity/synced?                      true
     :entity/icon                         :fa-eye-slash
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                             ;; problematic - if whe declare this - upon login user cannot see the account before role is set
                                             ;;(roles/is-ssg-role? role)
                                            true)}

    :entity.type/audit
    {:entity/icon                         :fa-file-edit
     :entity/disable-permissions-check-fn system-controlled-entity-delete-check}

     ;; AI service configuration
    :entity.type/ai-service
    {:entity/schema                       ai-service/schema
     :entity/icon                         :fa-robot
     :entity/read-permissions-check-fn    admin-check-fn
     :entity/disable-permissions-check-fn admin-delete-check-fn}

    :entity.type/ai-task-config
    {:entity/schema                       ai-task-config/schema
     :entity/icon                         :fa-robot
     :entity/read-permissions-check-fn    admin-check-fn
     :entity/disable-permissions-check-fn admin-delete-check-fn}

    :entity.type/ai-usage-event
    {:entity/schema                       ai-usage-event/schema
     :entity/icon                         :fa-robot
     :entity/read-permissions-check-fn    admin-check-fn
     :entity/disable-permissions-check-fn system-controlled-entity-delete-check}

     ;; NYLAS integration
    :entity.type/nylas-account
    {:entity/schema                       nylas-account/schema
     :entity/icon                         :fa-envelope
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                            false)
     :entity/disable-permissions-check-fn system-controlled-entity-delete-check}

    :entity.type/nylas-token
    {:entity/schema                       nylas-token/schema
     :entity/icon                         :fa-user
     :entity/read-permissions-check-fn    (fn [{:keys [entity account] :as _ctx}]
                                            (= (:db/id account)
                                               (-> entity :nylas-token/account :db/id)))
     :entity/disable-permissions-check-fn owner-admin-delete-check-fn}

     ;; generic entities
    :entity.type/any
    {:entity/icon                         :fa-project-diagram
     :entity/disable-permissions-check-fn abstract-entity-delete-check-fn
     :entity/read-permissions-check-fn    (constantly false)}

     ;; Deprecated entities
    :entity.type/kpi-report-template
     ;; TODO: seems like deprecated - further cleanup needed ?
    {:entity/disable-permissions-check-fn deprecated-entity-delete-check-fn
     :entity/icon                         :fa-chart-bar}

    :entity.type/custom-field
    {:entity/disable-permissions-check-fn admin-delete-check-fn
     :entity/read-permissions-check-fn    (constantly true)
     :entity/schema                       custom-field/schema
     :entity/icon                         :fa-ballot-check}

    :entity.type/check-list
    {:entity/disable-permissions-check-fn admin-delete-check-fn
     :entity/read-permissions-check-fn    (constantly true)
     :entity/schema                       check-list/schema
     :entity/icon                         :fa-check-square}

    :entity.type/liability
    {:entity/schema                       liability/schema
     :entity/icon                         :fa-exclamation-triangle
     :entity/read-permissions-check-fn    (fn [{:keys []}]
                                            true)
     :entity/disable-permissions-check-fn liability-delete-check-fn}

    :entity.type/signatory
    {:entity/schema                       signatory/schema
     :entity/icon                         :fa-pen
     :entity/synced?                      true
     :entity/read-permissions-check-fn    (fn [{:keys [tenant entity] :as ctx}]
                                            (let [tenant-id (:db/id tenant)
                                                  esign-process (->> entity
                                                                     :esign-process/_signatories
                                                                     (remove :common/disabled?)
                                                                     (remove #(not= tenant-id
                                                                                    (-> %
                                                                                        :common/tenant
                                                                                        :db/id)))
                                                                     first)
                                                  esign-process-ctx (assoc ctx :entity esign-process)]
                                              (esign-process-read-check-fn esign-process-ctx)))
     :entity/disable-permissions-check-fn abstract-entity-delete-check-fn}

    :entity.type/pre-investment-check
    {:entity/schema                       pre-investment-check/schema
     :entity/icon                         :fa-user-check
     :entity/synced?                      true
     :entity/read-permissions-check-fn    (fn [{:keys [entity entity-lookup account account-current-permissions] :as ctx}]
                                            (let [oppo-pre-investment-check-attributes
                                                  (->> oppo/schema
                                                       (filter (fn [[_attribute field]]
                                                                 (-> field
                                                                     :field/entity-types
                                                                     set
                                                                     (contains? :entity.type/pre-investment-check))))
                                                       (map first))
                                                  [oppo-field oppo-id] (->> oppo-pre-investment-check-attributes
                                                                            (map (fn [attr]
                                                                                   [attr
                                                                                    (->> attr
                                                                                         cu/reverse-attribute
                                                                                         (get entity)
                                                                                         first
                                                                                         :db/id)]))
                                                                            (remove (fn [[_attr value]]
                                                                                      (nil? value)))
                                                                            first)
                                                  oppo (entity-lookup oppo-id)
                                                  oppo-ctx (assoc ctx :entity oppo)
                                                  pipeline-id (-> oppo
                                                                  :oppo/pipeline
                                                                  :db/id)
                                                  oppo-field-permission (-> account-current-permissions
                                                                            :account-pipeline-field-access
                                                                            (get pipeline-id)
                                                                            :entity.type/oppo
                                                                            (get oppo-field))
                                                  can-read-oppo-attribute? (contains? #{:r :w} oppo-field-permission)]
                                              (cond
                                                (nil? oppo)
                                                (= (:db/id account)
                                                   (-> entity
                                                       :common/created-by
                                                       :db/id))

                                                can-read-oppo-attribute?
                                                (oppo-read-check-fn oppo-ctx)

                                                :else
                                                false)))
     :entity/disable-permissions-check-fn abstract-entity-delete-check-fn}
    :entity.type/pre-exit-check
    {:entity/schema                       pre-exit-check/schema
     :entity/icon                         :fa-user-check
     :entity/synced?                      true
     :entity/read-permissions-check-fn
     (fn [{:keys [entity entity-lookup account account-current-permissions] :as ctx}]
       (let [check-attributes
             (->> exit-opportunity/schema
                  (filter (fn [[_attribute field]]
                            (-> field
                                :field/entity-types
                                set
                                (contains? :entity.type/pre-exit-check))))
                  (map first))
             [exit-oppo-field
              exit-oppo-id] (->> check-attributes
                                 (map (fn [attr]
                                        [attr
                                         (->> attr
                                              cu/reverse-attribute
                                              (get entity)
                                              first
                                              :db/id)]))
                                 (remove (fn [[_attr value]]
                                           (nil? value)))
                                 first)
             exit-oppo (entity-lookup exit-oppo-id)
             exit-oppo-ctx (assoc ctx :entity exit-oppo)
             pipeline-id (-> exit-oppo
                             :exit-opportunity/pipeline
                             :db/id)
             exit-oppo-field-permission (-> account-current-permissions
                                            :account-pipeline-field-access
                                            (get pipeline-id)
                                            :entity.type/exit-opportunity
                                            (get exit-oppo-field))
             can-read-exit-oppo-attribute? (contains? #{:r :w}
                                                      exit-oppo-field-permission)]
         (cond
           (nil? exit-oppo)
           (= (:db/id account)
              (-> entity
                  :common/created-by
                  :db/id))

           can-read-exit-oppo-attribute?
           (exit-oppo-read-check-fn exit-oppo-ctx)

           :else
           false)))
     :entity/disable-permissions-check-fn abstract-entity-delete-check-fn}

    :entity.type/insider-group
    {:entity/schema insider-group/schema
     :entity/icon   :fa-users-class
     :entity/read-permissions-check-fn
     (fn [{:keys [account tenant entity role tenant-plan]}]
       (let [access? (and (plan/available :feature/insider-groups tenant role tenant-plan)
                          (or (roles/admin? role)
                              (= :insider-group.status/public (:insider-group/status entity))
                              (->> account
                                   :team/_members
                                   (filter (fn [t]
                                             (some #{:module/insider-groups-admin} (:team/modules t))))
                                   (seq))
                              (and (->> account
                                        :team/_members
                                        (filter (fn [t]
                                                  (some #{:module/insider-groups} (:team/modules t))))
                                        (seq))
                                   (or (some #{(:db/id account)}
                                             (->> entity
                                                  :insider-group/members
                                                  (keep (fn [m]
                                                          (cond (:db/id m)
                                                                (:db/id m)
                                                                (number? m)
                                                                m)))))
                                       (some (->> account
                                                  :team/_members
                                                  (map :db/id)
                                                  (set))
                                             (->> entity
                                                  :insider-group/teams
                                                  (map :db/id)))))))]
         #?(:clj (println "INSIDER GROUP " access? " < " (pr-str entity)))
         access?))}
    :entity.type/metabase-dashboard
    {:entity/schema metabase-dashboard/schema
     :entity/icon   :fa-tachometer-alt-slowest
     :entity/read-permissions-check-fn
     (fn [{:keys [account tenant entity role tenant-plan]}]
       (let [access? (and (plan/available :feature/metabase-dashboards tenant role tenant-plan)
                          (->> account
                               :team/_members
                               (filter (fn [t]
                                         (let [team-modules (set (:team/modules t))]
                                           (or (contains? team-modules
                                                          :module/dashboards-admin)
                                               (and (contains? team-modules
                                                               :module/dashboards)
                                                    (or (some #{(:db/id account)}
                                                              (->> entity :metabase-dashboard/members (map :db/id)))
                                                        (some (->> account
                                                                   :team/_members
                                                                   (remove :common/disabled?)
                                                                   (map :db/id)
                                                                   (set))
                                                              (->> entity
                                                                   :metabase-dashboard/teams
                                                                   (remove :common/disabled)
                                                                   (map :db/id)))))))))
                               (seq)))]
          ;;#?(:clj (println "Metabase dashboard " access? " < " (pr-str entity)))
         access?))}

    :entity.type/advisory-board-decision
    {:entity/schema                       advisory-board-decision/schema
     :entity/icon                         :fa-user-cog
     :entity/read-permissions-check-fn    decision-read-check-fn
     :entity/disable-permissions-check-fn decision-disable-permissions-check-fn}

    :entity.type/pm-approval-decision
    {:entity/schema                       pm-approval-decision/schema
     :entity/icon                         :fa-user-check
     :entity/read-permissions-check-fn    decision-read-check-fn
     :entity/disable-permissions-check-fn decision-disable-permissions-check-fn}

    :entity.type/aifm-exit-decision
    {:entity/schema                    aifm-exit-decision/schema
     :entity/icon                      :fa-hand-holding-seedling
     :entity/read-permissions-check-fn decision-read-check-fn}

    :entity.type/ic-exit-decision
    {:entity/schema                    ic-exit-decision/schema
     :entity/icon                      :fa-lightbulb-on
     :entity/read-permissions-check-fn decision-read-check-fn}

    :entity.type/one-pager-decision
    {:entity/schema                    one-pager-decision/schema
     :entity/icon                      :fa-lightbulb-on
     :entity/read-permissions-check-fn decision-read-check-fn}

    :entity.type/icm-decision
    {:entity/schema                    icm-decision/schema
     :entity/icon                      :fa-lightbulb-on
     :entity/read-permissions-check-fn decision-read-check-fn}

    :entity.type/scm-decision
    {:entity/schema                    scm-decision/schema
     :entity/icon                      :fa-lightbulb-on
     :entity/read-permissions-check-fn decision-read-check-fn}

    :entity.type/decision-condition
    {:entity/schema                       decision-condition/schema
     :entity/icon                         :fa-sliders-h
     :entity/read-permissions-check-fn    decision-condition-read-check-fn
     :entity/disable-permissions-check-fn decision-condition-disable-permissions-check-fn}

    :entity.type/decision-participant
    {:entity/schema                       decision-participant/schema
     :entity/icon                         :fa-user-tag
     :entity/read-permissions-check-fn    decision-participant-read-check-fn
     :entity/disable-permissions-check-fn decision-participant-disable-permissions-check-fn}

    :entity.type/investment-reservation
    {:entity/schema                       investment-reservation/schema
     :entity/icon                         :fa-lightbulb-dollar
     :entity/read-permissions-check-fn    investment-reservation-read-check-fn
     :entity/disable-permissions-check-fn investment-reservation-disable-permissions-check-fn}

    :entity.type/investment-reservation-type
    {:entity/schema                    investment-reservation-type/schema
     :entity/icon                      :fa-calendar-check
     :entity/read-permissions-check-fn decisions-access?
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr role] :as ctx}]
       (when-not (and (roles/admin? role)
                      (decisions-access? ctx))
         (tr :not-allowed)))}

    :entity.type/contact-list
    {:entity/schema contact-list/schema
     :entity/icon   :fa-list
     :entity/read-permissions-check-fn
     (fn [ctx]
       (feature-and-admin-or-module? ctx
                                     :feature/contact-lists
                                     :module/contact-lists))
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr] :as ctx}]
       (when-not (feature-and-admin-or-module? ctx
                                               :feature/contact-lists
                                               :module/contact-lists)
         (tr :not-allowed)))}

    :entity.type/graph-company
    {:entity/schema graph-company/schema
     :entity/icon   :fa-building
     :entity/read-permissions-check-fn
     entity-graph-access?
     :entity/disable-permissions-check-fn
     graph-entity-disable-check}

    :entity.type/graph-person
    {:entity/schema graph-person/schema
     :entity/icon   :fa-user
     :entity/read-permissions-check-fn
     entity-graph-access?
     :entity/disable-permissions-check-fn
     graph-entity-disable-check}

    :entity.type/graph-fund
    {:entity/schema graph-fund/schema
     :entity/icon   :fa-hand-holding-seedling
     :entity/read-permissions-check-fn
     entity-graph-access?
     :entity/disable-permissions-check-fn
     graph-entity-disable-check}

    :entity.type/graph-fof-asset
    {:entity/schema graph-fof-asset/schema
     :entity/icon   :fa-seedling
     :entity/read-permissions-check-fn
     entity-graph-access?
     :entity/disable-permissions-check-fn
     graph-entity-disable-check}

    :entity.type/graph-reference
    {:entity/schema graph-reference/schema
     :entity/icon   :fa-link
     :entity/read-permissions-check-fn
     entity-graph-access?
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr] :as ctx}]
       (when-not (entity-graph-access? ctx)
         (tr :not-allowed)))}

    :entity.type/graph-meta
    {:entity/schema graph-meta/schema
     :entity/icon   :fa-link
     :entity/read-permissions-check-fn
     entity-graph-access?
     :entity/disable-permissions-check-fn
     (fn [{:keys [tr] :as ctx}]
        ;;TODO we may have to prevent this if e.g. the containing
        ;;     graph-reference is of type :graph-reference.type/ownership
        ;;     AND ownership-percentage is considered as non-clearable.
        ;;     should be fine to allow in first release
       (when-not (entity-graph-access? ctx)
         (tr :not-allowed)))}

    :entity.type/project-counterparty-diligence
    {:entity/schema                       project-counterparty-diligence/schema
     :entity/read-permissions-check-fn    counterparty-diligence-read-check-fn
     :entity/disable-permissions-check-fn counterparty-diligence-delete-check-fn}

    :entity.type/company-counterparty-diligence
    {:entity/schema                       company-counterparty-diligence/schema
     :entity/read-permissions-check-fn    counterparty-diligence-read-check-fn
     :entity/disable-permissions-check-fn counterparty-diligence-delete-check-fn}

    :entity.type/person-counterparty-diligence
    {:entity/schema                       person-counterparty-diligence/schema
     :entity/read-permissions-check-fn    counterparty-diligence-read-check-fn
     :entity/disable-permissions-check-fn counterparty-diligence-delete-check-fn}

    :entity.type/counterparty-diligence-process
    {:entity/schema                       counterparty-diligence-process/schema
     :entity/read-permissions-check-fn    counterparty-diligence-process-read-check-fn
     :entity/disable-permissions-check-fn admin-delete-check-fn}

    :entity.type/zap-vault
    {:entity/schema                       zap-vault/schema
     :entity/read-permissions-check-fn    zap-vault-read-check-fn
     :entity/disable-permissions-check-fn (fn [{:keys [entity] :as ctx}]
                                            (and (admin-delete-check-fn ctx)
                                                 (:common/archived? entity)))}

    :entity.type/vault-config
    {:entity/schema vault-config/schema
     :entity/read-permissions-check-fn
     (fn [{:keys [entity tenant] :as ctx}]
       (let [vault (->> entity
                        :zap-vault/_configuration
                        (first))]
         (and (feature-and-module? ctx :feature/zap-vault :module/zap-vault)
              (or (= (eid/eid entity)
                     (eid/eid (:tenant/default-vault-config tenant)))
                  (zap-vault-read-check-fn (assoc ctx
                                                  :entity vault))))))
     :entity/disable-permissions-check-fn
     (fn [{:keys [entity tenant tr] :as ctx}]
       (let [vault (->> entity
                        :zap-vault/_configuration)]
         (when-not (and (feature-and-module? ctx :feature/zap-vault :module/zap-vault)
                        (or (= (eid/eid entity)
                               (eid/eid (:tenant/default-vault-config tenant)))
                            (zap-vault-read-check-fn (assoc ctx
                                                            :entity vault))))
           (tr :not-allowed))))}

    :entity.type/vault-usage
    {:entity/schema                       vault-usage/schema
     :entity/read-permissions-check-fn    (fn [ctx]
                                            (feature-and-admin-or-module? ctx
                                                                          :feature/zap-vault
                                                                          :module/zap-vault))
     :entity/disable-permissions-check-fn (fn [{:keys [tr] :as ctx}]
                                            (when-not (feature-and-admin-or-module? ctx
                                                                                    :feature/zap-vault
                                                                                    :module/zap-vault)
                                              (tr :not-allowed)))}

    :entity.type/transaction-process
    {:entity/schema                       transaction-process/schema
     :entity/icon                         :fa-exchange-alt
     :entity/read-permissions-check-fn    tp-access/can-access-transaction-process?
     :entity/disable-permissions-check-fn (fn [{:keys [tr] :as ctx}]
                                            (when-not (tp-access/can-access-transaction-process? ctx)
                                              (tr :not-allowed)))}

    :entity.type/attestation
    {:entity/schema                       attestation/schema
     :entity/read-permissions-check-fn    (fn [ctx]
                                            (can-access-tp-sub-entity? ctx))
     :entity/disable-permissions-check-fn (fn [{:keys [tr] :as ctx}]
                                            (when-not (can-access-tp-sub-entity? ctx)
                                              (tr :not-allowed)))}

    :entity.type/attestation-condition
    {:entity/schema                       attestation-condition/schema
     :entity/icon                         :fa-sliders-h
     :entity/read-permissions-check-fn    can-access-attestation-condition?
     :entity/disable-permissions-check-fn (fn [{:keys [tr] :as ctx}]
                                            (when-not (can-access-attestation-condition? ctx)
                                              (tr :not-allowed)))}

    :entity.type/declaration
    {:entity/schema                       declaration/schema
     :entity/read-permissions-check-fn    (fn [ctx]
                                            (can-access-tp-sub-entity? ctx))
     :entity/disable-permissions-check-fn (fn [{:keys [tr] :as ctx}]
                                            (when-not (can-access-tp-sub-entity? ctx)
                                              (tr :not-allowed)))}}
   (entity-type-registry/entity-type-definitions-backwards-compatible)))

(defn resolve-icon
  [entity-type]
  (get-in entities [entity-type :entity/icon]))

(def read-only-creatable-entity-types
  (->> entities
       (keep (fn [[entity-type meta]]
               (when (:entity/can-be-created-by-read-only-user? meta)
                 entity-type)))
       (set)))

(def zadmin-cross-tenant-entity-types
  "The entity types that a zadmin can read in a tenant other than the session
  tenant.

  A zadmin is Zapflow staff who configures a customer tenant. That work needs
  the tenant entity, its custom fields, its usage reports and its Metabase
  dashboards. It does not need the customer's business data, and a read of any
  other type from another tenant is refused and logged. See
  `backend.read-serialization/log-refused-cross-tenant-admin-read!`.

  A sys-admin account does not use this set. Its cross-tenant access is
  complete and is handled below."
  #{:entity.type/metabase-dashboard
    :entity.type/cached-report
    :entity.type/custom-field
    :entity.type/tenant})

(defn entity-can-be-accessed-by-tenant
  #_{:clj-kondo/ignore [:unused-binding]}
  [{:keys [handler-id entity tenant account role infof errorf entity-lookup]}]
  (let [id (:db/id entity)
        entity-type (:entity/type entity)
        tenant-id (:db/id tenant)]
    (or
     (contains? PUBLIC-ENTITY-TYPES-SET
                entity-type)
     (:account/system entity)
     ;; The session role and the account flag must both say zadmin. The role
     ;; alone is not enough, because `roles/zadmin?` is also true for a
     ;; sys-admin, and because a zadmin account keeps this access while it
     ;; works as :role/admin in its own tenant.
     (and (roles/zadmin? role)
          (:account/zadmin? account)
          (contains? zadmin-cross-tenant-entity-types entity-type))
     (let [entity-tenant (if (not (:common/tenant entity))
                           (do
                             (println handler-id " Reading entity from DB since missing :common/tenant : " id entity-type)
                             (:common/tenant (entity-lookup id)))
                           (:common/tenant entity))]
       (if (and entity-tenant
                tenant-id
                account
                (not= (:db/id tenant) (or (:db/id entity-tenant) entity-tenant))
                (not (:account/system account))
                ;; do not print out sys-admin actions, sys admin accounts are
                ;; currently in zapflow tenant only
                (not (:account/sys-admin? account))
                (not (:account/sys-admin? entity)))
         ;; The account id, not the entity: an EntityMap prints every attribute
         ;; that was read on it, such as the whole :account/current-permissions.
         (do (errorf "Accessing wrong tenant !!! %s not from %s [%s] ->> %s"
                     id
                     tenant-id
                     (:db/id account)
                     (:db/id entity-tenant))
             false)
         true)))))

(defn read-permissions?
  [{:keys [entity role infof] :as ctx}]
  (let [entity-type-def (->> entity
                             :entity/type
                             (get entities))]
    (if (not (entity-can-be-accessed-by-tenant ctx))
      (do (infof "Filter out not belonging to tenant %s" (:entity/type entity))
          false)
      (let [entity-filter (:entity/read-permissions-check-fn entity-type-def)]
        (or (and (roles/admin? role)
                 (not (:entity/apply-read-permissions-to-admin? entity-type-def)))
            (if entity-filter
              (entity-filter ctx)
              true))))))

(defn type->owner-attribute
  [type]
  (entity-ownership/entity-type-owner-attributes type))

(defn any-reference-type
  [target-assets-in-use]
  (set/difference (set any-reference-types)
                  (set/difference (set assets/all-asset-types)
                                  (set target-assets-in-use))))

(def synced-entities
  (->> entities
       (keep (fn [[entity-type entity-type-def]]
               (when (:entity/synced? entity-type-def)
                 entity-type)))
       (set)))

(defn is-entity-synced?
  [entity-type]
  (contains? synced-entities entity-type))
